import { useTranslation as useI18nTranslation } from 'react-i18next';
import type { TranslationNamespace } from '@/types/i18n';

/**
 * Type-safe translation hook wrapper
 * Provides translation functionality with namespace support
 *
 * @param namespace - Translation namespace to use (default: 'common')
 * @returns Translation function and i18next utilities
 *
 * @example
 * ```tsx
 * const { t } = useTranslation('customers');
 * return <h1>{t('title')}</h1>; // Translates 'customers.title'
 * ```
 */
export function useTranslation(namespace: TranslationNamespace = 'common') {
  return useI18nTranslation(namespace);
}
